export default __webpack_public_path__ + "assets/c67e6b312e2fd67c0a091333681552a1.png";